import { createContext, useContext, ReactNode, FC } from 'react';

type HomePageContextType = {
    isDesktop: boolean;
    isMobile: boolean;
    isTablet: boolean;
    isLoggedInUser: boolean;
    userType: string;
};

export const HomePageContext = createContext<HomePageContextType>({
    isDesktop: false,
    isMobile: false,
    isTablet: false,
    isLoggedInUser: false,
    userType: '',
});

type ServerVarsProviderProps = {
    children: ReactNode;
} & Required<HomePageContextType>;

export const useHomePageContext = (): HomePageContextType => {
    const context = useContext(HomePageContext);
    if (!context) {
        throw new Error('useHomePageContext must be used within a HomePageContextProvider');
    }
    return context;
};

export const HomePageContextProvider: FC<ServerVarsProviderProps> = ({
    children,
    isDesktop,
    isMobile,
    isTablet,
    isLoggedInUser,
    userType,
}) => {
    return (
        <HomePageContext.Provider
            value={{
                isMobile,
                isTablet,
                isDesktop,
                isLoggedInUser,
                userType,
            }}
        >
            {children}
        </HomePageContext.Provider>
    );
};
